import { Input, InputProps } from "@chakra-ui/react";
import React from "react";
import { NumberFormatValues, NumericFormat, OnValueChange, SourceInfo } from "react-number-format";

interface IProps {
  onChange?: (v: number) => void;
  value?: number;
  defaultValue?: number | string;
}
export default function InputCustom({value, defaultValue, onChange}: IProps) {
  const handleOnValueChange = (values: NumberFormatValues, sourceInfo: SourceInfo) => {
    return onChange && onChange(values.floatValue || 0);
  }
  return (
    <NumericFormat      
      focusBorderColor="transparent"
      allowNegative={false}
      decimalScale={1}
      thousandSeparator     
      onValueChange={handleOnValueChange}
      customInput={Input}
      value={value || defaultValue}
      defaultValue={defaultValue}
    />
  );
}
